import React from "react";
import "../designcss/Whatsappautomation.css";

const Whatsappautomate = () => {
  return (
    <>
      <section className="whatsappautomation">
        <div className="helpbusiness">
          <h1>Why Choose WoSender for Your WhatsApp Campaigns</h1>
          {/* <h1>with WhatsApp Automation</h1> */}
        </div>

        <p className="marketingsystem">
          WoSender is designed to simplify and scale WhatsApp marketing for
          businesses of all sizes. Here’s what sets us apart:
        </p>

        <div className="cardss-wrapperr">
          <div className="infoo-cardd">
            <h3>Easy WhatsApp API Integration</h3>
            <p>
              Get started quickly with a smooth and hassle-free setup using the
              official WhatsApp Business API. The integration process is simple,
              secure, and fully compliant with WhatsApp guidelines. Launch
              faster without technical complexity and start engaging customers
              instantly.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Bulk & Automated Messaging</h3>
            <p>
              Reach thousands of customers instantly with powerful bulk
              messaging tools. Automate campaigns to save time and maintain
              consistent communication. Deliver personalized messages
              efficiently at scale with minimal effort.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Secure & Policy-Compliant</h3>
            <p>
              Ensure high message delivery rates through WhatsApp-approved
              infrastructure. All communications strictly follow WhatsApp’s
              security and messaging policies. Build trust while keeping
              customer data protected and compliant.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Advanced Analytics</h3>
            <p>
              Track campaign performance with real-time analytics and detailed
              insights. Monitor delivery, engagement, and response metrics
              effortlessly. Use data-driven insights to optimize campaigns for
              better results.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Scalable Solutions</h3>
            <p>
              Designed to support businesses of all sizes, from startups to
              enterprises. Scale messaging operations seamlessly as your
              business grows. Enjoy reliable performance even with high message
              volumes.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Dedicated Support</h3>
            <p>
              Get expert assistance from setup to ongoing optimization. Our
              support team ensures smooth operations and quick issue resolution.
              Focus on growth while we handle the technical support.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Whatsappautomate;
